import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { TariffsRoutingModule } from './tariffs-routing.module';
import { TariffsPageComponent } from './tarriffs-page/tariffs-page.component';
import { TariffComponent } from './tariff/tariff.component';
import { SharedModule } from '../../shared/shared.module';
import { ModalModule } from '../../core/modal/modal.module';
import { VerticalTariffListComponent } from './vertical-tariff-list/vertical-tariff-list.component';
import { SelectTariffConnectionComponent } from './select-tariff-connection/select-tariff-connection.component';
import { SubscriptionsModule } from './subscriptions/subscriptions.module';
import { TariffDescriptionModalComponent } from './tariff-description-modal/tariff-description-modal.component';
import { TariffPricePipe } from './tariff-price.pipe';

const exportedComponents = [
  SelectTariffConnectionComponent,
  VerticalTariffListComponent,
];

@NgModule({
  imports: [
    TariffsRoutingModule,
    SharedModule,
    ModalModule,
    ReactiveFormsModule,
    SubscriptionsModule,
    ReactiveFormsModule,
  ],
  exports: [
    ...exportedComponents,
    TariffPricePipe,
  ],
  declarations: [
    ...exportedComponents,
    TariffPricePipe,
    TariffsPageComponent,
    TariffComponent,
    TariffDescriptionModalComponent,
  ],
  providers: [],
})
export class TariffsModule {
}
